import { Component, Input, OnInit, ViewChild, ElementRef } from '@angular/core';
import { environment } from 'src/environments/environment';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SignaturePad } from 'angular2-signaturepad';
import { AuthorizationBase } from '../../../core/authorize-base';
import { UserBase } from '../../../core/user-base';
import { AlertService } from '../../../core/alert.service';
import { AuthService } from '../../../core/auth.service';

@Component({
  selector: 'payment-confirm-action',
  templateUrl: './payment-confirm-action.component.html',
  styleUrls: ['./payment-confirm-action.component.scss'],
})
export class PaymentConfirmActionComponent
  extends AuthorizationBase
  implements OnInit
{
  @ViewChild('signContainer', { static: false }) signContainer: ElementRef
  @ViewChild('SignaturePad', { static: false }) signaturePad: SignaturePad;
  @Input() showModalOnRight: boolean = true;

  public user: UserBase;
  public signUrl: string;
  public hideUserPassword: boolean = false;

  EmpForm: string = 'EmployeePassword';
  CustForm: string = 'CustomerSign';

  baseUrl: string = '';
  clicked: boolean = false;
  isLoading: boolean = false;
  isShow: boolean = false;
  password: string;
  signatureExists: boolean = false;

  public signaturePadOptions: any = {
    // passed through to szimek/signature_pad constructor
    minWidth: 1,
    canvasWidth: 500,
    canvasHeight: 150,
    velocityFilterWeight: 0.2,
  };
  activeForm: string = this.CustForm;

  constructor(
    public authService: AuthService,
    private alert: AlertService,
    private activeModal: NgbActiveModal
  ) {
    super();
    this.user = new UserBase();
    this.baseUrl = environment.accountAPIRoot;
  }

  ngOnInit() {
    if (this.activeForm === this.CustForm) {
      setTimeout(() => {
        this.signaturePadOptions.canvasWidth = this.signContainer.nativeElement.offsetWidth;
        this.isShow = true;
      });
    }
  }

  toggleActiveForm() {
    this.clearSign();
    this.isShow = false;
    this.activeForm = this.activeForm === this.CustForm ? this.EmpForm : this.CustForm;

    if (this.activeForm === this.CustForm) {
      setTimeout(() => {
        this.signaturePadOptions.canvasWidth = this.signContainer.nativeElement.offsetWidth;
        this.isShow = true;
      });
    }
  }

  clearSign() {
    this.signatureExists = false;
    this.signaturePad.clear();
  }

  drawComplete() {
    // will be notified of szimek/signature_pad's onEnd event
    this.signatureExists = true;
    this.signUrl = this.signaturePad.toDataURL();
  }

  drawStart() {
    // will be notified of szimek/signature_pad's onBegin event
  }

  verifyAction() {
    this.isLoading = true;

    if (this.activeForm === this.EmpForm) {
      this.verifyPassword();
      return;
    }

    this.verifySignature();
  }

  verifySignature() {
    if (!this.signatureExists) {
      this.alert.alertError({ text: 'Please enter signature.' });
      this.isLoading = false;
      return;
    }
  
    this.isLoading = false;
    this.close({ signUrl: this.signUrl });
  }

  verifyPassword() {
    if (!this.password) {
      this.alert.alertError({ text: 'Please input password.' });
      this.isLoading = false;
      return;
    }

    this.isLoading = true;
    this.authService
      .verifyUserActionByPassword(Number(this.userId()), this.password)
      .subscribe(
        (res: any) => {
          if (res) {
            this.close(true);
          }
        },
        (error: any) => {
          this.isLoading = false;
          this.password = '';

          this.alert.alertError({ title: 'Error encountered', text: error.error });
        },
        () => {
          this.isLoading = false;
        }
      );
  }

  close(data?: any) {
    this.activeModal.close(data);
  }
}
